/**
 * Escapes characters in a string that have special meaning in a regular expression.
 * This is a common utility function to safely use user input or dynamic strings
 * within a RegExp constructor.
 *
 * @param {string} str The input string to escape.
 * @returns {string} The escaped string, safe to be used in a RegExp.
 */
export const escapeRegExp = (str: string): string => {
  // $& means the whole matched string
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};